import CrudService from "@/services/shared/http/CrudService";

export default class CustomerService extends CrudService {
  constructor(params = {}) {
    super("customers", params);
  }
}
